import { GA4Event} from "./GA4Event";

export function buildBookFound(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("book_found", {
		search_input: attributes.search_input || '',
		item_id: attributes.item_id || '',
		item_name: attributes.item_name || '',
		item_category: attributes.item_category || '',
		rebuy_price: attributes.rebuy_price || '',
		interaction: attributes.interaction || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
